import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMenuIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			opacity: .1,
			width: 32,
			height: 32,
			rx: 8,
			fill: "#2D3656"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 24.2002,
			y: 14.8008,
			width: 3.4,
			height: 3.4,
			rx: 1.7,
			transform: "rotate(90 24.2002 14.8008)",
			fill: "#2D3656"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 17.3999,
			y: 14.8008,
			width: 3.4,
			height: 3.4,
			rx: 1.7,
			transform: "rotate(90 17.3999 14.8008)",
			fill: "#2D3656"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 10.6006,
			y: 14.8008,
			width: 3.4,
			height: 3.4,
			rx: 1.7,
			transform: "rotate(90 10.6006 14.8008)",
			fill: "#2D3656"
		})
	]
});
export default SvgMenuIcon;
